import React from "react";

const ArtistPortfolioTemplate = ({ brandName, tagline, logo, colorTheme }) => {
  const colorClasses = {
    blue: "text-blue-600",
    green: "text-green-600",
    purple: "text-purple-600",
    red: "text-red-600",
  };

  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Header */}
      <header className="p-6 bg-gray-100 shadow flex items-center justify-between">
        <div className="flex items-center space-x-4">
          {logo && <img src={logo} alt="Logo" className="h-12" />}
          <div>
            <h1 className={`text-2xl font-bold ${colorClasses[colorTheme]}`}>
              {brandName || "Artist Name"}
            </h1>
            <p className="text-sm text-gray-600">
              {tagline || "Creative Portfolio"}
            </p>
          </div>
        </div>
        <nav className="hidden md:flex space-x-6 text-gray-700">
          <a href="#work" className="hover:underline">
            Portfolio
          </a>
          <a href="#about" className="hover:underline">
            About
          </a>
          <a href="#contact" className="hover:underline">
            Contact
          </a>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="flex-1 flex flex-col justify-center items-center bg-gradient-to-br from-purple-300 to-blue-300 py-20">
        <h2 className="text-4xl md:text-6xl font-extrabold text-white drop-shadow-md">
          {brandName || "Artist Name"}
        </h2>
        <p className="mt-4 text-lg text-white bg-black bg-opacity-40 px-4 py-2 rounded">
          {tagline || "Turning ideas into masterpieces"}
        </p>
      </section>

      {/* Portfolio/Work Section */}
      <section id="work" className="py-16 px-8 bg-gray-50">
        <h3
          className={`text-3xl font-bold mb-10 text-center ${colorClasses[colorTheme]}`}
        >
          Portfolio
        </h3>
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <div className="bg-white rounded shadow p-4">
            <div className="h-48 bg-gray-200 rounded mb-4"></div>
            <h4 className="text-lg font-semibold">Project Title</h4>
            <p className="text-sm text-gray-500">
              Short description of the artwork.
            </p>
          </div>
          <div className="bg-white rounded shadow p-4">
            <div className="h-48 bg-gray-200 rounded mb-4"></div>
            <h4 className="text-lg font-semibold">Project Title</h4>
            <p className="text-sm text-gray-500">
              Short description of the artwork.
            </p>
          </div>
          <div className="bg-white rounded shadow p-4">
            <div className="h-48 bg-gray-200 rounded mb-4"></div>
            <h4 className="text-lg font-semibold">Project Title</h4>
            <p className="text-sm text-gray-500">
              Short description of the artwork.
            </p>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 px-8 text-center">
        <h3 className={`text-3xl font-bold mb-6 ${colorClasses[colorTheme]}`}>
          About Me
        </h3>
        <p className="text-gray-700 max-w-2xl mx-auto">
          I'm a passionate artist who loves to explore the beauty of colors and
          forms. My works span digital illustration, fine arts, and photography,
          aimed to evoke emotions and tell stories.
        </p>
      </section>

      {/* Contact / Footer */}
      <footer id="contact" className="bg-gray-900 text-white py-8 text-center">
        <p>Let's create something beautiful together!</p>
        <p className="mt-2">Contact: info@example.com</p>
        <p className="mt-2">
          &copy; {new Date().getFullYear()} {brandName || "Artist"}. All rights
          reserved.
        </p>
      </footer>
    </div>
  );
};

export default ArtistPortfolioTemplate;
